import React from 'react';
import ReactDOM from 'react-dom';
import RealnamesResults from "realnames_results/RealnamesResults";

const node = document.getElementById("app");

// If there are no results, node might not be in the document
if (node) {
  const props = JSON.parse(node.getAttribute("data-props"));

  ReactDOM.render(
    <RealnamesResults { ...props }/>,
    node
  );
}
